// extracted by mini-css-extract-plugin
module.exports = {"cursor-pointer":"styles-module__cursor-pointer___22xX-","responsive-fs-1":"styles-module__responsive-fs-1___2EbLd","responsive-fs-6":"styles-module__responsive-fs-6___1jXIs"};